<template>
  <div />
</template>

<script lang="ts">
import { defineComponent, toRefs } from 'vue';
import { constant, utils, eventBus } from '@cpc/comment-sdk-common';
import wv, { showToast } from '@cpc/comment-sdk-jsapi';
import {
  useContactNative,
  useGlobalState,
  useNativeAbility,
  useCommentListInject,
} from '@cpc/comment-sdk-core-comment';

import { commonCommentStat } from '../core/useStat';

export default defineComponent({
  name: 'ContactNative',

  // props: {},

  setup() {
    const { pageType } = toRefs(useGlobalState());
    const { PageType } = constant;

    const { onSendComment, onGetFastComments, onDelComment } = useContactNative();
    const { reportCommentFailType } = useNativeAbility();
    const {
      getNewCommentContentById,
      getTopCommentContentById,
      commonCostTime,
    } = useCommentListInject();
    const { hasImgData, hasEmoji, query } = utils;

    onSendComment(
      (data) => {
        const videoSource = query.get('videoSource') || '';
        console.log('videoSource', videoSource);
        console.log('videoSource query.get', query.get('videoSource'));
        commonCommentStat(20084696, {
          isReply: !!data.commentId,
          strId: data.id,
          commentId: data.commentId ? data.commentId : '',
          commentContent: data.commentId
            ? getNewCommentContentById(data.commentId) || getTopCommentContentById(data.commentId)
            : data.comment,
          replyId: data.commentId ? data.id : '',
          replyContent: data.commentId ? data.comment : '',
          costTime: commonCostTime.value || 0,
          commType: data.fake ? data.fake : 0,
          hasGif: hasImgData('gif', data.imageList) || false,
          hasEmoji: hasEmoji(data.comment) || false,
          hasPic: hasImgData('img', data.imageList) || false,
          behaviorSource: data?.extension?.behaviorSource || 'normal',
          beRepliedId: data?.extension?.beRepliedId || '',
          videoSource,
        });

        const anchorType = data.commentId ? 'reply' : 'comment';

        const el = utils.$(`#${anchorType}_${data.id}`);

        el?.scrollIntoView({ block: 'start', behavior: 'smooth' });
        el?.classList.add('touch-feed-back');
        setTimeout(() => {
          el?.classList.remove('touch-feed-back');
        }, 500);

        if (data.commentId) {
          eventBus.emit('ANIMATION_CONTROL', false);
        }
      },
      (error) => {
        const { code, message, extra } = error;

        commonCommentStat(20084697, {
          isReply: !!extra.commentId,
          errorCode: code,
          errorMsg: message,
          commType: extra.fake ? extra.fake : 0,
          hasGif: hasImgData('gif', extra.imageList),
          hasEmoji: hasEmoji(extra.comment),
          hasPic: hasImgData('img', extra.imageList),
          commentContent: extra.commentId
            ? getNewCommentContentById(extra.commentId) || getTopCommentContentById(extra.commentId)
            : extra.comment,
          commentId: extra.commentId ? extra.commentId : '',
          replyContent: extra.commentId ? extra.comment : '',
          behaviorSource: extra?.extension?.behaviorSource || 'normal',
          beRepliedId: extra?.extension?.beRepliedId || '',
        });

        reportCommentFailType(error);
      },
    );

    onGetFastComments(
      () => {
        // do something
      },
      (error) => {
        console.error(error);
      },
    );

    onDelComment(
      (info) => {
        commonCommentStat(20084699, {
          isReply: !!info.replyId,
          costTime: commonCostTime.value || 0,
          strId: info.replyId ? info.replyId : info.commentId,
          commentId: info.commentId,
          commentContent: info.replyId
            ? getNewCommentContentById(info.commentId) || getTopCommentContentById(info.commentId)
            : info.content, //
          replyId: info.replyId ? info.replyId : '',
          replyContent: info.replyId ? info.content : '',
          commentPageType:
            pageType.value === constant.PageType.DEFAULT ? 'topComment' : 'secondComment',
        });

        const { replyId, replyNumOfComment: size } = info;
        const isSecondCommentDetail = pageType.value === PageType.SECOND_COMMENT_DETAIL;

        if (isSecondCommentDetail) {
          // 二级页面标题变化
          wv.asyncInvoke('onReplyCountChanged', [size, replyId ? size - 1 : 0]);
        }
      },
      (error) => {
        const { code, message } = error.error;

        const { commentId, replyId, content } = error.info;

        commonCommentStat(20084700, {
          isReply: !!commentId,
          errorCode: code,
          errorMsg: message,
          strId: replyId || commentId,
          commentId,
          commentContent: replyId
            ? getNewCommentContentById(commentId) || getTopCommentContentById(commentId)
            : content,
          replyId: replyId || '',
          replyContent: replyId ? content : '',
          commentPageType:
            pageType.value === constant.PageType.DEFAULT ? 'topComment' : 'secondComment',
        });

        console.log(commentId, replyId, content, 'info');

        console.log(code, message, 'delete error');

        console.error(error);
      },
    );

    return {};
  },
});
</script>

<style lang="scss" scoped></style>
